import { FC, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { SLOGAN } from "../../../utils/Contants";
import { routes } from "../../routes/RoutesComponent";
import "./FooterComponentStyles.scss";
import { FaFacebookF, FaInstagram, FaYoutube, FaLinkedinIn } from "react-icons/fa";
import Icons from "../../assets/Icons";
import { API_URL } from "../../../../config/env";

const FooterComponent: FC<{}> = () => {
    const [termAndConditionsLinks, setTermAndConditionsLinks] = useState([]);

    useEffect(() => {
        const getData = async () => {
            try {
                const res = await fetch(`${API_URL}/terms/no-contents`);
                const data = await res.json();
                setTermAndConditionsLinks(data);
            } catch (error) {}
        };
        getData();
    }, []);

    const [open, setOpen] = useState<number | undefined>(undefined);

    const _handleOpen = (index: number) => {
        if (open == index) setOpen(undefined);
        else setOpen(index);
    };

    const sedes = [
        {
            title: "Wcar Vitrina Ventas W4",
            city: "Bogotá",
            tab: "Vitrina W4",
            phone: "+57 324 8264550",
            address: "Calle 98A 69 55",
            img: "/assets/footer/sedes/sede-vitrina-w4.jpg",
        },
        {
            title: "Compramos tu Auto Usado Morato",
            city: "Bogotá",
            tab: "Compramos tu Auto",
            phone: "+57 324 4001212",
            address: "Calle 98a # 69 - 45",
            img: "/assets/footer/sedes/sede-compra-tu-carro-morato.jpg",
        },
        {
            title: "Wcar Caribe - Compra o Vende tu Auto",
            city: "Barranquilla",
            tab: "Barranquilla",
            phone: "+57 324 4001212",
            address: "Av. Circunvalar, Cl. 110 #43c91, Barranquilla, local A2-1",
            img: "/assets/footer/sedes/sede-barranquilla.jpg",
            coords: "11.0009614,-74.8417441",
        },
        {
            title: "Taller",
            city: "Bogotá",
            tab: "Taller",
            phone: "+57 324 8264550",
            address: "Cr 69b #98-28",
            img: "/assets/footer/sedes/sede-taller.jpg",
        },
        {
            title: "Wcar Cajicá - Chía",
            city: "Cajicá",
            tab: "Cajicá - Chía",
            phone: "+57 324 4001212",
            address: "Cra 5 #9-26 sur Cajicá. Torre 3 - Local 3",
            img: "/assets/footer/sedes/sede-cajica-chia.jpg",
        },
        {
            title: "Wcar Puente Aranda",
            city: "Bogotá",
            tab: "Puente Aranda",
            phone: "+57 324 4001212",
            address: "Carrera. 50 #15-55 Bogotá",
            img: "/assets/footer/sedes/sede-puente-aranda.jpg",
        },
        {
            title: "Wcoffee Morato",
            city: "Bogotá",
            tab: "Wcoffee",
            phone: "+57 324 4001212",
            address: "Cll 98a #69B-35",
            img: "/assets/footer/sedes/sede-wcoffee.jpg",
        },
        {
            title: "Wcar La Felicidad",
            city: "Bogotá",
            tab: "La Felicidad",
            phone: "+57 324 4001212",
            address: "Cl. 17 #80A-30, Bogotá, Colombia",
            img: "/assets/footer/sedes/sede-la-felicidad.jpg",
        },
        {
            title: "Punto de Venta Morato",
            city: "Bogotá",
            tab: "Morato",
            phone: "+57 324 4001212",
            address: "Cll 98a #69B-35",
            img: "/assets/footer/sedes/sede-morato.jpg",
        },
    ];

    const [selectedSede, setSelectedSede] = useState(0);
    const [cityFilter, setCityFilter] = useState<string>("Todas");
    const sede = sedes[selectedSede];
    const cities = Array.from(new Set(sedes.map((item) => item.city)));
    const mobileSedes = sedes
        .map((item, index) => ({ item, index }))
        .filter(({ item }) => cityFilter === "Todas" || item.city === cityFilter);
    const sedeAddress = sede.address.includes(sede.city) ? sede.address : `${sede.address}, ${sede.city}`;

    const _handleCityFilter = (city: string) => {
        setCityFilter(city);
        const first = sedes.findIndex((item) => city === "Todas" || item.city === city);
        if (city !== "Todas" && sedes[selectedSede].city !== city && first >= 0) setSelectedSede(first);
    };
    const sedeQuery = sede.coords ?? encodeURIComponent(`${sede.address}, Colombia`);
    const otherSedes = sedes.map((item, index) => ({ item, index })).filter(({ index }) => index !== selectedSede);

    const socialLinks = [
        { to: "https://www.facebook.com/wcarcolombia?mibextid=ZbWKwL", label: "Facebook", Icon: FaFacebookF },
        {
            to: "https://www.instagram.com/wcar.oficial?igshid=NGVhN2U2NjQ0Yg%3D%3D",
            label: "Instagram",
            Icon: FaInstagram,
        },
        { to: "https://www.youtube.com/@wcarcolombia?si=SAfvApSkimvFnxHK", label: "Youtube", Icon: FaYoutube },
        { to: "https://www.linkedin.com/company/wcarcol/", label: "LinkedIn", Icon: FaLinkedinIn },
    ];

    return (
        <footer className="wf">
            <div className="wf-container">
                {/* TARJETAS SUPERIORES */}
                <div className="wf-top">
                    <div className="wf-card wf-card-brand">
                        <img src="/assets/logos/horizontal-on-orange.svg" alt="wcar" title="wcar" width={130} height={40} />
                        <span className="wf-slogan">
                            <strong>{SLOGAN.split(",")[0]},</strong>
                            <br />
                            {SLOGAN.split(",")[1]?.trim()}
                        </span>
                        <div className="wf-brand-block">
                            <p className="wf-bar-title wf-bar-white">Síguenos</p>
                            <div className="wf-social">
                                {socialLinks.map(({ to, label, Icon }) => (
                                    <Link key={label} to={to} target="_blank" aria-label={label} className="wf-social-item">
                                        <Icon size={14} />
                                    </Link>
                                ))}
                            </div>
                        </div>
                        <div className="wf-brand-block">
                            <p className="wf-bar-title wf-bar-white">Contacto</p>
                            <Link to="mailto:contacto@wcar.co">contacto@wcar.co</Link>
                            <Link to="tel:+573244001212">+57 324 4001212</Link>
                        </div>
                    </div>

                    <div className="wf-card wf-card-menu">
                        <p className="wf-bar-title">Menú</p>
                        <ul>
                            <li>
                                <Link to={routes.aboutUs.relativePath}>Nuestra empresa</Link>
                            </li>
                            <li>
                                <Link to={routes.buyYourCar.relativePath}>Compra tu carro</Link>
                            </li>
                            <li>
                                <Link to={routes.sellYourCar.relativePath}>Vende tu carro</Link>
                            </li>
                            <li>
                                <Link to={routes.services.relativePath}>Financiación</Link>
                            </li>
                            <li>
                                <Link to={routes.insurance.relativePath}>Seguros</Link>
                            </li>
                            <li>
                                <Link to={routes.procedures.relativePath}>Trámites</Link>
                            </li>
                        </ul>
                    </div>

                    <div className="wf-card wf-card-terms">
                        <p className="wf-bar-title wf-terms-title">Términos y condiciones</p>
                        <ul>
                            <li>
                                <Link to="/aviso-de-privacidad-de-datos-para-usuarios-app-wcar/20" rel="nofollow">
                                    Aviso de privacidad de datos para usuarios
                                </Link>
                            </li>
                            <li>
                                <Link to="/politicas-de-privacidad-de-la-aplicacion-movil-wcar/21" rel="nofollow">
                                    Políticas de privacidad
                                </Link>
                            </li>
                        </ul>
                        <div className="wf-accordion">
                            <div className="wf-accordion-item">
                                <button type="button" className="wf-accordion-header" onClick={() => _handleOpen(1)}>
                                    <span>Términos y condiciones Website wcar</span>
                                    {1 == open ? <Icons.Clear /> : <Icons.Plus />}
                                </button>
                                {1 == open && (
                                    <ul className="wf-accordion-content">
                                        {termAndConditionsLinks.map((termAndConditionsLink, i: number) => {
                                            if (!termAndConditionsLink.is_app) {
                                                return (
                                                    <li key={i}>
                                                        <Link
                                                            rel="nofollow"
                                                            to={`/${termAndConditionsLink.url}/${termAndConditionsLink.id}`}
                                                        >
                                                            {termAndConditionsLink.title}
                                                        </Link>
                                                    </li>
                                                );
                                            }
                                            return null;
                                        })}
                                        <li>
                                            <Link to={"/politicas-comprador"} rel="nofollow">
                                                Términos y condiciones comprador
                                            </Link>
                                        </li>
                                    </ul>
                                )}
                            </div>
                            <div className="wf-accordion-item">
                                <button type="button" className="wf-accordion-header" onClick={() => _handleOpen(2)}>
                                    <span>Mas términos y condiciones</span>
                                    {2 == open ? <Icons.Clear /> : <Icons.Plus />}
                                </button>
                                {2 == open && (
                                    <ul className="wf-accordion-content">
                                        {termAndConditionsLinks.map((termAndConditionsLink, i: number) => {
                                            if (termAndConditionsLink.is_app) {
                                                return (
                                                    <li key={i}>
                                                        <Link
                                                            rel="nofollow"
                                                            to={`/${termAndConditionsLink.url}/${termAndConditionsLink.id}`}
                                                        >
                                                            {termAndConditionsLink.title}
                                                        </Link>
                                                    </li>
                                                );
                                            }
                                            return null;
                                        })}
                                        <li>
                                            <Link to={"/politicas-comprador"} rel="nofollow">
                                                Términos y condiciones comprador
                                            </Link>
                                        </li>
                                    </ul>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                {/* SEDES */}
                <div className="wf-sedes">
                    <div className="wf-tabs" role="tablist">
                        {sedes.map((item, index) => (
                            <button
                                key={item.title}
                                type="button"
                                role="tab"
                                aria-selected={index === selectedSede}
                                className={`wf-tab ${index === selectedSede ? "active" : ""}`}
                                onClick={() => setSelectedSede(index)}
                            >
                                {item.tab}
                            </button>
                        ))}
                    </div>

                    <div className="wf-sedes-body">
                        <div className="wf-map">
                            <iframe
                                key={sede.address}
                                title={`Mapa ${sede.title}`}
                                src={`https://maps.google.com/maps?q=${sedeQuery}&z=16&output=embed`}
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                            />
                            <div className="wf-detail">
                                <img src={sede.img} alt={`Sede ${sede.title}`} />
                                <div className="wf-detail-info">
                                    <span className="wf-badge">Vendedor</span>
                                    <p className="wf-detail-title">{sede.title}</p>
                                    <p className="wf-detail-contact">
                                        <Link to={`tel:${sede.phone.replace(/\s/g, "")}`}>{sede.phone}</Link>
                                        <span className="wf-sep" />
                                        <span>{sede.address}</span>
                                    </p>
                                </div>
                                <div className="wf-detail-actions">
                                    <a
                                        className="wf-btn wf-btn-maps"
                                        href={`https://www.google.com/maps/search/?api=1&query=${sedeQuery}`}
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        <img src="/assets/footer/google-maps-icon.png" alt="" width={16} height={20} />
                                        Google Maps
                                    </a>
                                    <a
                                        className="wf-btn wf-btn-waze"
                                        href={`https://waze.com/ul?q=${sedeQuery}&navigate=yes`}
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        <img src="/assets/footer/waze-icon.png" alt="" width={38} height={39} />
                                        WAZE
                                    </a>
                                </div>
                            </div>
                        </div>

                        <div className="wf-list">
                            {otherSedes.map(({ item, index }) => (
                                <button
                                    key={item.title}
                                    type="button"
                                    className="wf-list-item"
                                    onClick={() => setSelectedSede(index)}
                                >
                                    <img src={item.img} alt={`Sede ${item.title}`} />
                                    <span>
                                        <strong>{item.title}</strong>
                                        <em>{item.phone}</em>
                                        <small>{item.address}</small>
                                    </span>
                                </button>
                            ))}
                        </div>
                    </div>
                </div>


                {/* SEDES MOBILE */}
                <div className="wf-m-sedes">
                    <p className="wf-m-kicker">Visítanos</p>
                    <h4 className="wf-m-heading">
                        Nuestras <i>sedes</i>
                    </h4>
                    <div className="wf-m-map">
                        <iframe
                            key={`m-${sede.address}`}
                            title={`Mapa ${sede.title}`}
                            src={`https://maps.google.com/maps?q=${sedeQuery}&z=16&output=embed`}
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                        />
                    </div>
                    <div className="wf-m-detail">
                        <img src={sede.img} alt={`Sede ${sede.title}`} />
                        <div className="wf-m-detail-info">
                            <span className="wf-badge">Vendedor</span>
                            <p className="wf-m-detail-title">{sede.title}</p>
                            <p className="wf-m-detail-address">{sedeAddress}</p>
                            <Link className="wf-m-detail-phone" to={`tel:${sede.phone.replace(/\s/g, "")}`}>
                                {sede.phone}
                            </Link>
                        </div>
                        <div className="wf-m-actions">
                            <a
                                className="wf-btn wf-btn-maps"
                                href={`https://www.google.com/maps/search/?api=1&query=${sedeQuery}`}
                                target="_blank"
                                rel="noreferrer"
                            >
                                <img src="/assets/footer/google-maps-icon.png" alt="" width={16} height={20} />
                                Google Maps
                            </a>
                            <a
                                className="wf-btn wf-btn-waze"
                                href={`https://waze.com/ul?q=${sedeQuery}&navigate=yes`}
                                target="_blank"
                                rel="noreferrer"
                            >
                                <img src="/assets/footer/waze-icon.png" alt="" width={38} height={39} />
                                WAZE
                            </a>
                        </div>
                    </div>
                    <div className="wf-m-filters" role="tablist">
                        {["Todas", ...cities].map((city) => (
                            <button
                                key={city}
                                type="button"
                                role="tab"
                                aria-selected={cityFilter === city}
                                className={`wf-tab ${cityFilter === city ? "active" : ""}`}
                                onClick={() => _handleCityFilter(city)}
                            >
                                {city} · {city === "Todas" ? sedes.length : sedes.filter((i) => i.city === city).length}
                            </button>
                        ))}
                    </div>
                    <p className="wf-m-hint">Todas las sedes · desliza</p>
                    <div className="wf-m-carousel">
                        {mobileSedes.map(({ item, index }) => (
                            <button
                                key={item.title}
                                type="button"
                                className={`wf-m-card ${index === selectedSede ? "active" : ""}`}
                                onClick={() => setSelectedSede(index)}
                            >
                                <img src={item.img} alt={`Sede ${item.title}`} />
                                <strong>{item.title}</strong>
                                <small>{item.city}</small>
                            </button>
                        ))}
                    </div>
                </div>

                {/* BARRA INFERIOR */}
                <div className="wf-bottom">
                    <div className="wf-bottom-info">
                        <img
                            src="/assets/logos/industria_y_comercio.png"
                            alt="supertendencia"
                            title="supertendencia"
                            loading="lazy"
                            decoding="async"
                        />
                        <p>wcar - Todos los derechos reservados © {new Date().getFullYear() || 2026}</p>
                    </div>
                    <ul>
                        <li>
                            <Link to="/politica-de-privacidad" rel="nofollow">
                                Políticas y tratamiento de datos
                            </Link>
                        </li>
                        <li>
                            <Link to="/politicas-comprador" rel="nofollow">
                                Términos y condiciones comprador
                            </Link>
                        </li>
                        <li>
                            <Link to="/politicas-vendedor" rel="nofollow">
                                Términos y condiciones vendedor
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>
        </footer>
    );
};

export default FooterComponent;
